// src/Admin/utils.js — small helpers shared by the admin screens

// Download rows (array of objects) as a CSV. A BOM is added so Excel shows Arabic correctly.
export const downloadCsv = (filename, rows) => {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]);
  const escape = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`;
  const lines = [headers.map(escape).join(','), ...rows.map((r) => headers.map((h) => escape(r[h])).join(','))];
  const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Firestore Timestamp | ms | ISO string -> Date (or null)
export const toDate = (value) => {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatDateTime = (value) => {
  const d = toDate(value);
  return d ? d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : '—';
};

export const formatDate = (value) => {
  const d = toDate(value);
  return d ? d.toLocaleDateString(undefined, { dateStyle: 'medium' }) : '—';
};

export const STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'done', label: 'Done' },
];

// Enrollments: missing status = new. Messages keep the older `read` flag for compatibility.
export const enrollmentStatus = (e) => e.status || 'new';
export const messageStatus = (m) => m.status || (m.read ? 'done' : 'new');
